import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Pagination, Autoplay } from "swiper/modules";
import { GoArrowUpRight } from "react-icons/go";
import Link from "next/link";
import WsrvImage from "../utils/WsrvImage";

export default function BookSlider({ data }) {
  const [categoryId, setCategoryId] = useState(null);
  const [product, setProduct] = useState([]);
  const [baseProducts, setBaseProducts] = useState([]);

  useEffect(() => {
    const dataList = data?.advanceData?.data || [];

    const filteredList = dataList.filter(
      (el) => el?.linkedProduct?.category === "659d195b4278df2b9163e8c6"
    );

    setBaseProducts(filteredList);
    setProduct(filteredList);
  }, [data]);

  useEffect(() => {
    if (categoryId) {
      const filtered = baseProducts.filter(
        (el) => el?.eduStandard?.id === categoryId
      );
      setProduct(filtered);
    } else {
      setProduct(baseProducts);
    }
  }, [categoryId, baseProducts]);

  const handleData = (id) => {
    if (categoryId === id) {
      setCategoryId(null);
    } else {
      setCategoryId(id);
    }
  };

  return (
    <section className="pt-12 md:pt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 gap-6 lg:gap-4">
          {/* Sidebar */}
          <div className="col-span-12 md:col-span-3 lg:col-span-2">
            {data?.heading && (
              <h2 className="text-2xl md:text-3xl font-bold text-[#163758] mb-4">
                {data?.heading}
              </h2>
            )}

            <ul>
              {data?.advanceData?.eduStandard?.map((item, i) => (
                <li
                  key={i}
                  onClick={() => handleData(item.id)}
                  className={`cursor-pointer px-4 py-2 mb-2 text-sm md:text-lg rounded-md transition 
            ${
              item.id === categoryId
                ? "bg-[#CF6335] text-white"
                : "text-[#555]"
            }`}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>

          {/* Book Cards */}
          <div className="col-span-12 md:col-span-9 lg:col-span-10 relative">
            {product.length > 0 ? (
              <div className="w-full">
                <Swiper
                  className="w-full toppers-slider"
                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  observer={true}
                  observeParents={true}
                  modules={[Pagination, Autoplay]}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 12,
                    },
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 16,
                    },
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 16,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    1280: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                    1536: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                  }}
                >
                  {product.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="border border-[#C3A3A3] lg:rounded-none rounded-md p-4 bg-white  flex flex-col min-h-[200px] md:min-h-[260px]">
                        <div className="flex flex-col lg:flex-row   gap-6 flex-grow">
                          <div className=" xl:w-40 lg:w-36 ">
                            <WsrvImage
                              src={item?.thumb || item?.linkedProduct?.thumb || "https://i.filecdn.in/844twof/book1-1756379148330.jpg"}
                              alt={item?.eduStandard?.name || item?.name || "Book"}
                              preset="thumb"
                              width={160}
                              height={220}
                              sizes="(max-width: 768px) 50vw, 160px"
                              className="w-full h-auto object-cover"
                            />
                          </div>

                          <div className="">
                            <div className="flex md:flex-col flex-row justify-between md:justify-start md:gap-0 gap-4">
                              <h3 className="text-[#163758] text-xl xl:text-2xl font-bold leading-snug">
                                {item?.eduStandard?.name}
                                <span className="text-[#000000] block text-lg xl:text-lg font-medium">
                                  XI Foundation
                                </span>
                              </h3>
                              <p className="text-[#CF6335] font-bold text-xl lg:text-2xl mt-2">
                                ₹ {item?.cost || item?.linkedProduct?.cost}
                              </p>
                            </div>
                            <Link
                              href={`/courses/details/${
                                item?.uri || item?.linkedProduct?.uri
                              }`}
                              className="text-[#555] md:text-base m-auto md:m-0 text-lg lg:text-lg py-3 lg:py-8 mt-4 flex items-center gap-1 self-start"
                            >
                              View details{" "}
                              <GoArrowUpRight className="text-[#CF6335] w-4 h-4 font-bold" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : (
              <div className="text-center mt-20 font-bold text-4xl   bg-white  py-6">
                Available Soon...
              </div>
            )}

            <div className="bg-[#FBD242] h-28 md:h-[175px] w-full md:w-[83%] absolute -z-10 -bottom-6 md:-bottom-8 top-[120px] right-[1px] hidden md:block rounded-tr-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

